<template>
    <el-dialog  title="app信息编辑" :visible.sync="showBlock" :destroy-on-close="true" width="500px" :before-close="handleClose">
        <div class="warp-form">
            <el-form :model="formDate" ref="formDate" label-width="80px" class="demo-ruleForm">
                <el-form-item  label="APP类型">
                    <el-select v-model="formDate.type" placeholder="请选择">
                        <el-option v-for="(item,index) in this.$store.state.conText.appType" :key="item.title+index" :label="item.title" :value="item.val"></el-option>
                    </el-select>
                </el-form-item>	
                <el-form-item  label="版本号" prop="releaseVersion"   :rules="[{required:true,message:'版本号内容不能为空'}]">
                    <el-input v-model="formDate.releaseVersion" maxlength="40" placeholder="请输入版本号" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item  label="上架时间" prop="onlineTime"   :rules="[{required:true,message:'上架时间不能为空'}]">
                    <el-date-picker  v-model="formDate.onlineTime" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间" default-time="12:00:00"></el-date-picker>
                </el-form-item>				
				<el-form-item  label="文件apk" prop="resource"   :rules="[{required:true,message:'文件ap内容不能为空'}]">
				    <el-input v-model="formDate.resource" maxlength="8" placeholder="请上传文件apk" autocomplete="off"></el-input>
                    <UploadApk @getUpload="getUpload"/>
				</el-form-item>
                <el-form-item  label="状态" >
                    <el-select v-model="formDate.status" placeholder="请选择">
                        <el-option v-for="(item,index) in this.$store.state.conText.stateList" :key="item.title+index" :label="item.title" :value="item.val"></el-option>
                    </el-select>
                </el-form-item>	
                <el-form-item  label="备注信息" prop="remark" :rules="[{required:true,message:'备注信息不能为空'}]">
                    <el-input v-model="formDate.remark" type="textarea" maxlength="500" placeholder="请输入新增内容" show-word-limit :autosize="{minRows:3}"  autocomplete="off"></el-input>
                </el-form-item>
                <div class="warp-btn">
                    <el-form-item>
                        <div  class="dialog-footer">
                            <el-button @click="handleClose">取消</el-button>
                            <el-button type="primary" @click="submitForm('formDate')">提交</el-button>
                        </div>
                    </el-form-item>
                </div>
            </el-form>
        </div>
    </el-dialog>
</template>
<script>
  import {url,operate} from '@/utils/config'
  import {postFun,putFun} from '@/utils/httpFun'
  import UploadApk from '@/components/component-block/block-uploadApk.vue'
  export default{
     components:{
        UploadApk:UploadApk
     },
     data(){
       return{
            maks:'add',
            id:"",
            formDate: {
                type:1,           //1安卓 2IOS     
				releaseVersion:"",       //版本号
                onlineTime: "",   //上架时间
                resource:"",//资源
                remark: "",//备注
                status:1,         //状态 1启用 0禁用
            },
            showBlock: false,
		
       }
     }, 
     created(){
       
     },
     methods:{

        //关闭弹窗
        handleClose() {
            this.showBlock = false
            this.formDate={
                type:1,           //1安卓 2IOS     
                releaseVersion:"",       //版本号
                onlineTime: "",   //上架时间
                resource:"",      //资源
                remark: "",       //备注
                status:1,         //状态 1启用 0禁用
            }
        },
        //上传成功的文件
        getUpload(ev){
            this.formDate.resource = ev
        },

        //提交
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
            if (valid) {
                this.addMess()
                } else {
                  return false;
                }
            });
        },

        //新增BTn
        addMess(){
            this.formDate.operator = this.$store.state.operator
            if(!!this.id){
                this.formDate.id = this.id
            }
            if(this.mark=="add"){
                postFun(operate.INSERTAPP,this.formDate,res=>{
                    if(res.data){
                    this.$parent.resetBtn()
                    this.handleClose()
                    }
                })
            }else{
                putFun(operate.UPDATEAPP,this.formDate,res=>{
                    if(res.data){
                    this.$parent.resetBtn()
                    this.handleClose()
                    }
                })
            }
        },

        //开启弹窗
        showMessage(ev){
           console.log(ev) 
           this.mark = ev.mark
           this.showBlock = true
           if(ev.mark=="eidt"){
               this.id = ev.id
               this.formDate={
                    type:ev.type,             
                    releaseVersion:ev.releaseVersion,       
                    onlineTime:ev.onlineTime,  
                    resource:ev.resource,
                    remark:ev.remark,
                    status:ev.status ? 1:0        
            }
           }
        }
     }
  }
</script>
<style scoped lang="scss">
   .dialog-footer{
       display: flex;
       justify-content: flex-end;
   }
   .warp-btn{
    .el-form-item {
        margin-bottom:0px!important;
     }
   }
   .warp-form{
      ::v-deep .el-input__count{
         background-color: rgba(0, 0, 0, 0);
      }
   }
   
</style>